module.exports = __webpack_public_path__ + "static/media/drumMachine.eb1b0ebd.png";